import stateClass, {TOGGLE_ACTIVE_EVENT} from '../baseState';

var LoadingState = new stateClass;


export {LoadingState, TOGGLE_ACTIVE_EVENT}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/loading/state.js